import type { KgInspectorIconKey } from "./kgInspectorIcons";
import type { InspectorTabConfig } from "./panelConfig";

export const ARTIFACT_TABS: InspectorTabConfig[] = [
  { id: "overview", label: "Overview" },
  { id: "activity", label: "Activity" },
];

export const ARTIFACT_HEADER_ICON: KgInspectorIconKey = "artifactPanel";
